import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import {
  ICreditTransaction,
  ICreditTransactionFilters,
} from "../types/creditTransaction";
import { IPaginatedResponse } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

const useCreditTransactions = (filters?: ICreditTransactionFilters) => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["credit-transactions", filters],
    queryFn: () => {
      const params = new URLSearchParams();
      if (filters?.urban_partner) {
        params.append("urban_partner", filters.urban_partner.toString());
      }
      if (filters?.source_type) {
        params.append("source_type", filters.source_type);
      }
      if (filters?.start) {
        params.append("start", filters.start);
      }
      if (filters?.end) {
        params.append("end", filters.end);
      }

      const queryString = params.toString();
      const url = `${API}/api/semeadora/credit-transactions/${queryString ? `?${queryString}` : ""}`;

      return fetch(url, {
        method: "GET",
      }) as Promise<IPaginatedResponse<ICreditTransaction>>;
    },
  });
};

export default useCreditTransactions;
